import { IAvatarSettings, TAvatar } from './types';

export const iframeAddress = process.env['NX_PUBLIC_IFRAME_ADDRESS'];

export function encodeValues<T extends object>(object: T): T {
	for (const key in object) {
		const value = object[key];

		if (typeof value === "object" && value !== null) {
			encodeValues(value);
			continue;
		}

		if (typeof value !== "string") {
			continue;
		}

		const encoded = encodeURIComponent(value) as (typeof object)[typeof key];

		if (value === encoded) {
			continue;
		}

		object[key] = encoded;
		// console.log(`encoded from: ${value} --> ${encoded}`)
	}

	return object;
}


const encodeConfig = (obj: object) =>
  window.btoa(unescape(encodeURIComponent(JSON.stringify(encodeValues(obj)))));

export const avatarObjectBuilder = (
  avatar: TAvatar,
  lists: { sceneList: Record<string, any>[] } = { sceneList: [] }
) => {
  const { type, greeting, voice, prompt, language, scene, logo } = avatar;
  const { sceneList } = lists;
  return {
    avatar: {
      initial: type,
      list: [{ id: type, icon: '', title: 'Name' }],
    },
    personality: {
      voice,
      prompt,
      ttsEngine: "elevenlabs_regular",
      // chatEngine: "",
    },
    locale: {
      initial: language,
    },
    texts: {
      greeting,
    },
    ui: {
      logo,
    },
    scene: {
      initial: scene,
      list: [{ id: scene, title: 'random', icon: '' }],
    },
    camera: {
      initial: "metahumans/visper",
    },
  };
};

// export const avatarUrlBuilder = (avatar: TAvatar, lists?: any): string => {
//   const config = encodeConfig(avatarObjectBuilder(avatar, lists));
//   return iframeAddress + '?settings=' + config;
// };

export const avatarUrlBuilder = (avatarSettings: IAvatarSettings): string => {
  console.log("avatarSettings", avatarSettings);
  const config = encodeConfig(avatarSettings);
  return iframeAddress + '?settings=' + config;
};

export const voices = [
  { value: 'jsCqWAovK2LkecY7zXl4', description: 'Freya' },
  { value: 'zcAOhNBS3c14rBihAFp1', description: 'Giovanni' },
  { value: 'JBFqnCBsd6RMkjVDRZzb', description: 'George' },
];
